import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['card', 'errors', 'paymentMethodToken', 'submit'];
  static values = { key: String, clientSecret: String };

  connect() {
    let stimulus = this;
    let stripe = Stripe(this.keyValue);
    let elements = stripe.elements();
    let classes = {
      base: "form-control"
    }
    let style = {
      base: {
        lineHeight: '1.5',
        fontSize: '16px'
      }
    }

    let card = elements.create('card', {
      iconStyle: 'solid',
      classes: classes,
      style: style
    });
    card.mount(this.cardTarget);

    card.on('change', function (event) {
      stimulus.displayError(event);
    });
    this.element.addEventListener('submit', async (e) => {
      e.preventDefault();

      stripe.confirmCardSetup(
        stimulus.clientSecretValue,
        {
          payment_method: {
            card: card
          }
        }
      ).then(function(result) {
        if (result.error) {
          stimulus.submitTarget.disabled = false;
          console.log(result.error);
        } else {
          stimulus.paymentMethodTokenTarget.value = result.setupIntent.payment_method;

          stimulus.submitTarget.disabled = true;
          stimulus.element.submit();
        }
      });
    });
  }

  displayError(event) {
    if (event.error) {
      this.submitTarget.disabled = false;
      this.errorsTarget.textContent = event.error.message;
      this.errorsTarget.classList.remove("d-none");
    } else {
      this.errorsTarget.textContent = '';
      this.errorsTarget.classList.add("d-none");
    }
  }
}